import { render, staticRenderFns } from "./ActualizacionReciente.vue?vue&type=template&id=55cf85a0"
import script from "./ActualizacionReciente.vue?vue&type=script&lang=js"
export * from "./ActualizacionReciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports